export function setDynamicListing(data) {
  return { type: 'SET_DYNAMIC_LISTING', data };
}
